<ngx-intl-tel-input-pure
  #intlTelInput
  [preferredCountries]="[CountryISO.Russia, CountryISO.Kazakhstan]"
  [enableAutoCountrySelect]="!countrySelected"
  [separateDialCode]="false"
  [enablePlaceholder]="true"
  [searchCountryFlag]="true"
  [selectFirstCountry]="false"
  [selectedCountryISO]="selectedCountryISO"
  [formControl]="internalControl"
  [value]="internalContolValue"
  [inputId]="inputId"
  [cssClass]="inputClass"
  [phoneValidation]="false"
  searchCountryPlaceholder="Поиск"
  i18n-searchCountryPlaceholder
  (countryChange)="countryChanged($event)"
  appFV
  (click)="phoneInputFocused()"
  [appFVControl]="control"
  [appFVOnlyBorder]="false"
></ngx-intl-tel-input-pure>

<!--<input class="hidden-input" type="text"-->
<!--       appFV-->
<!--       [appFVOnlyBorder]="false"-->
<!--       [formControl]="control">-->
